import { ConfigProvider, theme as antdTheme } from "antd";

import { useThemeEffect } from "@/hooks/useThemeEffect";
import { AppRoutes } from "@/routes/AppRoutes";

export function App() {
  const mode = useThemeEffect();
  const isDark = mode === "dark";

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          borderRadius: 2,
          colorPrimary: isDark ? "#ffffff" : "#0a0a0a",
          colorLink: isDark ? "#ffffff" : "#0a0a0a",
          fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
        }
      }}
    >
      <AppRoutes />
    </ConfigProvider>
  );
}
